import * as React from 'react';

import { FrequencyContainer } from './FrequencyContainer';
import * as styles from './styles/subscription.css';
import { EType } from '../../../../../repositories/subscriptions/entities/schemas/GetSubscriptionsResponseSchema';
import { TDeviceType } from '../../../../../store';
import { ISubscriptionIsActiveParams, ISubscriptionsDeletedParams } from '../../../../../store/subscriptions';
import { trackingPageType, trackSubscriptionDelete, trackSubscriptionToggle } from '../../../../../tracking';
import { getToggleLabel, serializeDeviceType, serializeLabel } from '../../../../../utils/tracking';
import { SubscriptionContent } from '../../../../base/SubscriptionContent';
import { Toggle } from '../../../../base/Toggle';
import { Close } from '../../../../base/icons';
import { TFrequenciesList } from '../../SubscriptionsSection';

export interface ISubscriptionStoreProps {
  deviceType: TDeviceType;
  token: string | null;
}

export interface ISubscriptionDispatchProps {
  deleteSubscriptionItem(params: ISubscriptionsDeletedParams): void;
  onChange(params: ISubscriptionIsActiveParams): void;
}

export interface ISubscriptionOwnProps {
  /** Пропы основного контента подписки */
  categoryName: string;
  itemId: number;
  title: string;
  subtitle: string;
  /** Пропы дополнительного контента подписки (частота рассылок) */
  frequency?: string;
  frequenciesList: TFrequenciesList | null;
  /** Пропы экшена подписки (тоггл или что-то ещё) */
  type: EType;
  isActive: boolean;
  /** Url для перехода в подписку - например: сохраненный поиск */
  url?: string;
}

export type ISubscriptionProps = ISubscriptionStoreProps & ISubscriptionDispatchProps & ISubscriptionOwnProps;

export class Subscription extends React.Component<ISubscriptionProps, {}> {
  public render() {
    const { title, subtitle, url } = this.props;

    return (
      <div className={styles['subscription']}>
        <div className={styles['main_content']}>
          <SubscriptionContent title={title} subtitle={subtitle} url={url} />

          <div className={styles['action']}>{this.getAction()}</div>
        </div>

        <div className={styles['addition_content']}>{this.getAdditionContent()}</div>
      </div>
    );
  }

  private deleteSubscription = () => {
    const { deleteSubscriptionItem, categoryName, itemId } = this.props;

    deleteSubscriptionItem({
      categoryName,
      itemId,
    });
  };

  private getAction = () => {
    const { isActive, type, itemId, categoryName } = this.props;
    const toggleParams = {
      categoryName,
      itemId,
      prevIsActive: isActive,
    };

    switch (type) {
      case EType.Toggle:
        return <Toggle defaultChecked={isActive} onChange={() => this.onToggleClick(toggleParams)} />;

      case EType.Delete:
        return (
          <span onClick={this.onDeleteClick}>
            <Close />
          </span>
        );

      default:
        return '';
    }
  };

  private getAdditionContent = () => {
    const { frequenciesList, frequency, itemId, categoryName, isActive } = this.props;

    if (frequenciesList && frequenciesList.length > 0) {
      return (
        <div className={styles['addition_content_item']}>
          <FrequencyContainer
            itemId={itemId}
            isEnabled={isActive}
            options={frequenciesList}
            selectedValue={frequency}
            categoryName={categoryName}
          />
        </div>
      );
    }

    return '';
  };

  private onDeleteClick = () => {
    const { categoryName, deviceType, subtitle } = this.props;

    const page = {
      pageType: trackingPageType,
      siteType: serializeDeviceType(deviceType),
    };

    const options = {
      label: serializeLabel({ categoryName, subtitle }),
      page,
    };

    this.deleteSubscription();
    trackSubscriptionDelete(options);
  };

  private onToggleClick = (params: ISubscriptionIsActiveParams) => {
    const { onChange, isActive, categoryName, frequency, deviceType } = this.props;

    const page = {
      pageType: trackingPageType,
      siteType: serializeDeviceType(deviceType),
    };

    const options = {
      isActive,
      label: getToggleLabel({ categoryName, frequency }),
      page,
    };

    trackSubscriptionToggle(options);
    onChange(params);
  };
}
